import { useEffect, useState } from "react";

// Whether dev-only / super-user features should be revealed. These are hidden by
// default and surfaced while the user holds a modifier, so they stay out of the way.
//
// This should typically be paired with the "super-user" feature switch.
export const useDevOptionsRevealed = (): boolean => {
  const [devOptionsRevealed, setDevOptionsRevealed] = useState(false);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Shift") {
        setDevOptionsRevealed(event.type === "keydown");
      }
    };
    window.addEventListener("keydown", handler);
    window.addEventListener("keyup", handler);
    return () => {
      window.removeEventListener("keydown", handler);
      window.removeEventListener("keyup", handler);
    };
  }, []);

  return devOptionsRevealed;
};
